import { render, staticRenderFns } from "./PartyShareStep.vue?vue&type=template&id=2d244a52"
import script from "./PartyShareStep.vue?vue&type=script&lang=js"
export * from "./PartyShareStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports